const padNumber = (number: number) => number.toString().padStart(2, '0');

// NOTE: Converts video duration from milliseconds to format `HH:mm:ss`
export const useGetVideoDuration = (duration?: number): string | undefined => {
  if (!duration) {
    return undefined;
  }

  const totalSeconds = Math.floor(duration / 1000);
  const totalSecondsWithoutHours = Math.floor(totalSeconds % 3600);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSecondsWithoutHours / 60);
  const seconds = Math.floor(totalSecondsWithoutHours % 60);

  if (hours) {
    return `${padNumber(hours)}:${padNumber(minutes)}:${padNumber(seconds)}`;
  }

  return `${padNumber(minutes)}:${padNumber(seconds)}`;
};
